// DepartmentDropdown.js

import React, { useEffect, useRef, useState, useCallback } from "react";
import { Form, Select, Input } from 'antd';
import DepartmentsApi from '../Apis/DepartmentsApi';
import DesignationApi from "../Apis/DesignationApi";

const ParentDesignation = ({ designation}) => {
    const [departments, setDepartments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);

    const fetchDepartments = async () => {
        try {
            setLoading(true);
            DesignationApi.ListDesignation(page, 10)
                .then((response) => {

                    // setDepartments(response?.payloadDto);
                    setTotalPageNew(response.totalPages);
                    setDepartments(prevDepartments => [...prevDepartments, ...response?.payloadDto]);

                    setPage(prevPage => prevPage + 1);
                    setLoading(false);

                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (error) {
            console.error('Error fetching departments:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        const nearBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1; // Add a small buffer
        if (bottom || nearBottom) {
            if (TotalPageNew > page) {
                fetchDepartments();
            }
        }
    };
    useEffect(() => {

        fetchDepartments();
    }, []);

    return (
        <><Form.Item
            name="parentDesignation"
            label="Parent Designation *"
            className="text-lable"
            rules={[
                {
                    required: true,
                    message: "Please Select Parent Designation.",
                },
            ]}
        >
            <Select
                className="control-Select mb-3"
                placeholder="Select Parent Designation"
                onPopupScroll={handleScroll} // Add scroll event listener
            >
                <Select.Option value="No_Parent_Designation">
                    No Parent Designation
                </Select.Option>
                {departments.filter(item => item.description !== designation).map((option, index) => (
                    <Select.Option key={option.id} value={option.id}> 
                        {option.description}
                    </Select.Option>
                ))}
                {loading && (
                    <Select.Option disabled key="loading" value="loading">
                        Loading...
                    </Select.Option>
                )}
            </Select>

        </Form.Item>
        </>
    );
};

export default ParentDesignation;
